module.exports = __webpack_public_path__ + "img/CC-BY-NC-SA.80fb4a8b.png";